// extracted by mini-css-extract-plugin
module.exports = {"hamburgerMenu":"styles_hamburgerMenu__1U-CZ","title":"styles_title__2VeT0","signOutBtn":"styles_signOutBtn__1_Z9_","signOut":"styles_signOut__3qELG"};